import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import SvgIcon, { SvgIconTypeMap } from '@material-ui/core/SvgIcon/SvgIcon'
import clsx from 'clsx'
import React from 'react'

const TwoColumnIcon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> = (
    props: any
) => (
    <SvgIcon
        width="38"
        height="38"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        className={clsx('twoColumnIcon', props.className)}
        htmlColor="transparent"
    >
        <path
            d="M7.33331 11H17.4166"
            stroke="white"
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.33331 18.3333H17.4166"
            stroke="white"
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.33331 25.6667H17.4166"
            stroke="white"
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.33331 33H17.4166"
            stroke="white"
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M26.5833 11H36.6666"
            stroke="white"
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M26.5833 18.3333H36.6666"
            stroke="white"
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M26.5833 25.6667H36.6666"
            stroke="white"
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M26.5833 33H36.6666"
            stroke="white"
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
)

export default TwoColumnIcon
